module.exports = __webpack_public_path__ + "img/31.2483c4ff.jpg";